export default "__VITE_PUBLIC_ASSET__b7982b61__"